/*
 * Analytics services wrapper
 *
 * FOSSA currently uses:
 * - Heap
 */

import { window } from '../globals';

export const track = (eventName: string, eventProps: { [key: string]: string | number }) => {
  if (window.heap) {
    window.heap.track(eventName, eventProps);
  }
};
